import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {Subject} from "rxjs";

interface User {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    rights?: string[];
}

interface Client {
    slug: string;
    url: string;
    name: string;
    logo: string;
    logoSmall: string;
    email: string;
    primaryColor: string;
}

@Injectable({
    providedIn: 'root'
})
export class AccessService {

    clientLoaded : Subject<boolean> = new Subject<boolean>();

    private _token: string = '';
    private _user: User|null = null;
    private _client: Client|null = null;

    get token() {
        return this._token;
    }

    set token(token: string) {
        this._token = token;
    }

    get user() {
        return this._user;
    }

    set user(user: any) {
        this._user = user;
    }

    set client(client: any) {
        this._client = client;
        this.clientLoaded.next(true);
    }

    get client() {
        return this._client;
    }

    hasRight(right: string): boolean {
        if (!this._user) return false;
        if (!this._user.rights) return false;

        return this._user.rights.includes(right);
    }

    environmentIsDev(): boolean {
        return environment.appVersion.endsWith('local') || environment.appVersion.endsWith('dev');
    }

}
